export default "__VITE_ASSET__D_UpwMvB__"